import { api } from '@/api/client';
import type { TaobaoOrder } from './types';
export function saveTaobaoOrder(id: string | undefined, payload: Record<string, unknown>) {
  return id ? api.patch<TaobaoOrder>(`/api/v2/taobao/orders/${encodeURIComponent(id)}`, payload) : api.post<TaobaoOrder>('/api/v2/taobao/orders', payload);
}
export function completeTaobaoOrder(id: string) { return api.post<TaobaoOrder>(`/api/v2/taobao/orders/${encodeURIComponent(id)}/complete`, {}); }
export function deleteTaobaoDraft(id: string) { return api.delete(`/api/v2/taobao/orders/${encodeURIComponent(id)}`); }
export function returnTaobaoOrder(id: string, lines: Array<{ orderLineId: string; quantity: number }>, note: string) {
  return api.post(`/api/v2/taobao/orders/${encodeURIComponent(id)}/return`, { lines, note });
}
